import { Component, computed, inject, input, output } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { TableSelectionService } from '../../services/table-selection.service';

export type DatatableCheckboxToggleEvent = {
  checked: boolean;
  shiftKey: boolean;
  selectionId: any;
};

@Component({
  selector: 'table-datatable-checkbox',
  templateUrl: './datatable-checkbox.component.html',
  styleUrls: ['./datatable-checkbox.component.scss'],
  imports: [MatCheckboxModule],
})
export class DatatableCheckboxComponent {
  selectionId = input<any>();
  isCompactMode = input(false);

  checkboxToggle = output<DatatableCheckboxToggleEvent>();

  private tableSelectionService = inject(TableSelectionService);
  private shiftKeyPressed = false;

  onCheckboxMouseDown(event: MouseEvent) {
    this.shiftKeyPressed = event.shiftKey;
  }

  onCheckboxClick(event: MouseEvent) {
    this.shiftKeyPressed = event.shiftKey;
  }

  onCheckboxToggle({ checked }: MatCheckboxChange) {
    const id = this.selectionId();
    if (id != null) this.tableSelectionService.toggleCheckbox(id);
    this.checkboxToggle.emit({
      checked,
      shiftKey: this.shiftKeyPressed,
      selectionId: id,
    });
    this.shiftKeyPressed = false;
  }

  isChecked = computed(() => {
    const selection = this.tableSelectionService.selectionSignal();
    return selection?.includes(this.selectionId());
  });
}
